module.exports = __webpack_public_path__ + "img/Belgravia_Logo_RGB_DarkGrey.61508973.png";